<template>
  <section id="reset-password">
    <SACSetPassword infoText="Create new password" buttonLabel="Reset Password" :processing="processing"
      :createPassword="createPassword" :error="error" :success="success" />

  </section>
</template>

<script>
import axios from 'axios';

import SACSetPassword from '../components/sac/SACSetPassword.vue';

export default {
  name: 'SetPasswordView',
  components: {
    SACSetPassword,
  },
  data() {
    return {
      processing: false,
      error: '',
      success: '',
      techSuccess: '',
    };
  },
  methods: {
    async createPassword(password) {
      try {
        const userId = JSON.parse(localStorage.currentUser).customerId;

        await axios({
          method: 'PUT',
          url: `${process.env.API_URL}/auth/admin/change-password`,
          data: {
            password,
            id: userId,
          },
        });
        this.success = 'Password updated successfully. Redirecting to login page...';
        setTimeout(() => {
          this.$store.dispatch('showSuccessToast', {
            message: 'Your password has been successfully updated',
          });
          this.$router.replace('/settings');
        }, 2000);
      } catch (err) {
        if (err.response) {
          const {
            data,
          } = err.response;
          if (data) {
            const {
              message,
            } = data;
            this.error = message;
          }
        } else {
          this.error = 'Token has expired or user does not exist';
        }
      }
      this.processing = false;
    },
  },
};
</script>

<style lang="scss">
section#reset-password {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: $WHITE;

  .success-container {
    width: 450px;
    height: 200px;
    background-color: $BASIL100;
    color: $WHITE;
    padding: 2rem;
    box-shadow: 0 1px 10px 0 rgb(9 15 32 / 10%);
    border-radius: 12px;
    font-size: 1.125rem;
    font-weight: 500;
    text-align: center;

    @media (max-width: 420px) {
      width: 300px;
      font-size: 1rem;
    }
  }
}
</style>
